import { create } from "zustand";
import { getBranding, type BrandingState } from "../api/branding";

interface BrandingStoreState extends BrandingState {
  loaded: boolean;
  load: () => Promise<void>;
  set: (s: BrandingState) => void;
}

const DEFAULT: BrandingState = {
  app_name: "VMS Dahua",
  has_logo: false,
  logo_ext: null,
  updated_at: 0,
};

export const useBrandingStore = create<BrandingStoreState>((set) => ({
  ...DEFAULT,
  loaded: false,
  load: async () => {
    try {
      const s = await getBranding();
      set({ ...s, loaded: true });
      try { document.title = s.app_name || "VMS"; } catch { /* SSR safe */ }
    } catch {
      set({ ...DEFAULT, loaded: true });
    }
  },
  set: (s) => {
    set({ ...s, loaded: true });
    try { document.title = s.app_name || "VMS"; } catch { /* noop */ }
  },
}));
